<template>
    <div>
      <md-table id="cart-summary" table-header-color="blue" class="md-card-header-blue">
        <md-table-row>
          <md-table-head>Produkt</md-table-head>
          <md-table-head style="width: 95px">Preis</md-table-head>
          <md-table-head style="width: 45px" v-if="!readOnly"></md-table-head>
        </md-table-row>

        <md-table-row v-for="item in cartItems" :key="item.key">
          <md-table-cell>
            {{ item.merchandise.title }}
            <span v-if="formatSelectedOptions(item)" class="md-caption">
              ({{ formatSelectedOptions(item) }})
            </span>
          </md-table-cell>
          <md-table-cell style="text-align: right">{{ item.merchandise.price === 0 ? '' : formatCurrency(item.merchandise.price) }}</md-table-cell>
          <md-table-cell v-if="!readOnly">
            <md-button class="md-icon-button md-simple" @click="$emit('delete', item)">
              <md-icon>clear</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>


        <md-table-row>
          <md-table-cell style="text-align: right; vertical-align: top;">
            Zwischensumme:<br>
            <span v-if="shippingCost > 0">Versand:<br></span>
            <span v-if="voucherDiscount > 0">Gutschein:<br></span>
          </md-table-cell>
          <md-table-cell style="text-align: right; vertical-align: top;">
            {{ formatCurrency(cartPrice) }}<br>
            <span v-if="shippingCost > 0">{{ formatCurrency(shippingCost) }}<br></span>
            <span v-if="voucherDiscount > 0">-{{ formatCurrency(voucherDiscount) }}<br></span>
            <div class="md-caption" v-if="hasShipping && shippingCost ==  null">
              zzgl. Versand
            </div>
          </md-table-cell>
          <md-table-cell v-if="!readOnly"></md-table-cell>
        </md-table-row>

        <md-table-row class="md-subheading" v-if="hasDonationFormSlot">
          <md-table-cell style="text-align: right; vertical-align: top;" colspan="2">
            <slot name="donationForm"></slot>
          </md-table-cell>
          <md-table-cell v-if="!readOnly"></md-table-cell>
        </md-table-row>

        <md-table-row class="md-subheading">
          <md-table-cell style="text-align: right; vertical-align: top;">
            Gesamt:
          </md-table-cell>
          <md-table-cell style="text-align: right; vertical-align: top;">
            {{ formatCurrency(totalPrice) }}
          </md-table-cell>
          <md-table-cell v-if="!readOnly"></md-table-cell>
        </md-table-row>
      </md-table>
      <div class="mt-4 md-subheading">
      <span v-if="donationAmount > 0">Deine Bestellung enthält eine Spende in Höhe von: </span>
      <span v-if="donationAmount > 0">{{ formatCurrency(donationAmount) }}</span>
      </div>
    </div>
</template>

<script>
import { voucherApplicableMerchandiseItem } from './CartUtils';
import currencyUtils from '@/utils/currency';

export default {
  props: ['cartItems', 'currency', 'priceInfo', 'readOnly', 'donationForm'],
  computed: {
    voucherDiscount() {
      return this.priceInfo && this.priceInfo.voucherInfo && this.priceInfo.voucherInfo.discount;
    },
    cartPrice() {
      return this.priceInfo && this.priceInfo.cartPrice;
    },
    totalPrice() {
      return this.priceInfo && this.priceInfo.payableAmount;
    },
    donationAmount() {
      return this.priceInfo && this.priceInfo.donationAmount;
    },
    hasShipping() {
      return this.priceInfo && this.priceInfo.hasShipping;
    },
    shippingCost() {
      return this.priceInfo && this.priceInfo.shippingCost;
    },
    hasDonationFormSlot() {
      return !!this.$slots.donationForm;
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyUtils.formatCurrency(value, this.currency);
    },
    formatField(field, formData) {
      const input = formData[field.name];
      if (input == null || input == '') {
        return null;
      }
      let value = input;
      if (field.fieldType === 'select') {
        let selectedOption = field.options.find(s => s.value === input);
        if (selectedOption && selectedOption.display != null || selectedOption.display != '') {
          value = selectedOption.display;
        }
      } else if (field.fieldType === 'checkbox') {
        value = input === true ? 'ja' : 'nein';
      }
      return `${field.title}: ${value}`;
    },
    formatSelectedOptions(item) {
      let formatedOptions = [];
      if (item.selectedOptions && item.merchandise.options) {
        formatedOptions = item.merchandise.options.map(field => {
          return this.formatField(field, item.selectedOptions);
        }).filter(label => label != null);
      }

      let formatedDonationOptions = []
      if (item.donationFormData && this.donationForm) {
        formatedDonationOptions = this.donationForm.map(field => {
          return this.formatField(field, item.donationFormData);
        }).filter(label => label != null);
      }

      return [...formatedOptions, ...formatedDonationOptions].join(', ');
    }
  }
};
</script>
<style lang="css" scoped>
#cart-summary {
  margin: 0;
}
  /* div#cart-summary .md-table-head-label {
    font-size: 1.2rem;
  }
  div#cart-summary .md-table-cell {

    font-size: 1.2rem;
    font-weight: 400;
  } */
</style>
